import { Component, Input, OnInit } from "@angular/core";
import { ActivatedRoute, ParamMap } from "@angular/router";
import { JobDto, JobMachineDto } from "@shared/models";
import { Observable } from "rxjs";
import { map, switchMap } from "rxjs/operators";
import {
  JobService,
  ProductSettingService,
} from "../../common/services";

@Component({
  selector: "abi-job-machine-print",
  templateUrl: "./job-machine-print.component.html",
  styleUrls: ["./job-machine-print.component.scss"],
})
export class JobMachinePrintComponent implements OnInit {
  private jobId: string;
  deliveryNoteId: string;
  public tenant: string;

  validationMessages = {};
  @Input() job: JobDto;
  lines: JobMachineDto[];
  today = Date.today();
  noteName = "Collection Document";

  companyName: string;
  addressLine1: string;
  addressLine2: string;
  addressLine3: string;
  addressLine4: string;
  addressLine5: string;
  postalCode: string;
  email: string;
  countryCode: string;
  websiteURL: string;
  registrationNumber: string;
  vatNumber: string;

  orderColumns = Array<{
    field: string;
    header: string;
    reverse: boolean | null;
  }>();

  constructor(
    private route: ActivatedRoute,
    private jobService: JobService,
    private productSettings: ProductSettingService
  ) {
    this.orderColumns = [
      { field: "lineId", header: "Line.", reverse: null },
      { field: "itemId", header: "Item", reverse: null },
      { field: "description", header: "Description", reverse: null },
      { field: "serial", header: "Serial", reverse: null },
      { field: "action", header: "Action", reverse: null },
      { field: "location", header: "Location", reverse: null },
      { field: "quantity", header: "Ordered", reverse: null },
      // { field: "delivered", header: "Delivered", reverse: null }
      // { field: "all", header: "All", reverse: null }
    ];

    this.tenant = route.snapshot.paramMap.get("tenant");
  }

  ngOnInit(): void {
    this.productSettings
      .getCompanyInfo(new Date())
      .toPromise()
      .then((info) => {
        this.companyName = info.name;
        this.addressLine1 = info.lines[0];
        this.addressLine2 = info.lines[1];
        this.addressLine3 = info.lines[2];
        this.addressLine4 = info.lines[3];
        this.addressLine5 = info.lines[4];
        this.postalCode = info.postalCode;
        this.countryCode = info.country;
        this.websiteURL = info.website;
        this.registrationNumber = info.registrationNumber;
        this.vatNumber = info.vatNumber;
        this.email = info.emailAddress;
        // this.email = info.emailAddress;
        // this.telephone = info.telephone;
      });

    this.route.paramMap
      .pipe(
        switchMap((params: ParamMap) =>
          this.readParams(params.get("jobId"), params.get("deliverynote"))
        )
      )
      .subscribe(([job, lines]) => (this.job = job, this.lines = lines));
  }

  getColumns() {
    return this.orderColumns;
  }

  private processJob(job: JobDto, deliverynote: string): [JobDto, JobMachineDto[]] {
    const lines = job.machines.map(l => {
      if (!l.machine)
      l.machine = job.machine;
      return l;
    }).filter(l => l.deliveryNote === deliverynote);
    return [job, lines];
  }

  private readParams(jobId: string, deliveryNoteId: string  ): Observable<[JobDto, JobMachineDto[]]> {
    this.jobId = jobId;
    this.deliveryNoteId = deliveryNoteId;
    //    this.deliveryNoteId = deliveryNoteId;
    return this.jobService.getJob(jobId).pipe(map(j => this.processJob(j, deliveryNoteId) ));
  }

  columnStyle(col: string, reverse: boolean | null) {
    let style = "";
    switch (col) {
      case "customerId":
      case "description":
      case "serial":
      case "action":
      case "location":
      case "itemId":
      case "poNumber":
        style = "no-left-pad";
        break;
      case "lineId":
      case "orderId":
        style = "px150"; // no-left-pad
        break;
      default:
        style = "px100 text-center";
    }
    return style;
  }

  ordered(line: JobMachineDto) {
    switch (line.action) {
      case "Return":
      case "Uplift":
        return -1;
    }
    return 1;
  }

  print(): Promise<void> {
    const observ = this.jobService.printDeliveryNote(this.jobId, this.deliveryNoteId);
    return observ.toPromise().then(x => { });
  }

  delete(content) {
    /*
    this.modal Service.open(content).result.then((result) => {
      this.salesOrderService
        .deleteDeliveryNote(this.deliveryNoteId)
        .toPromise()
        .then(x => this.location.back());
    }, (reason) => {

    });*/
  }
}
